import { ComboboxOption } from "@headlessui/react";
import { cn } from "~/lib/utils";
import { MouseEvent } from "react";
import {
    SearchWindowHeaderRow,
    SearchWindowVirtualRowProps,
} from "../../types";

// // // //

/**
 * Renders a section header row for the search window
 * NOTE - this is rendered as a disabled ComboboxOption because the Combobox
 * virtualizer only measures + positions ComboboxOption elements
 */
export function SearchWindowHeader(
    props: {
        row: SearchWindowHeaderRow;
        onClearRecentSearches?: () => void;
    } & SearchWindowVirtualRowProps,
) {
    const { row, onClearRecentSearches, ...virtualRowProps } = props;

    // Handle clearing recent searches
    const handleClearRecentSearches = (
        event: MouseEvent<HTMLButtonElement>,
    ) => {
        event.preventDefault();
        event.stopPropagation();
        onClearRecentSearches?.();
    };

    return (
        <ComboboxOption
            {...virtualRowProps}
            as="div"
            value={row}
            disabled
            className={cn("w-full pb-2", { "pt-2": !row.isFirst })}
        >
            <div
                className={cn(
                    "bg-card px-4 py-2.5 text-sm font-normal text-muted-foreground border-b flex items-center justify-between gap-4",
                    { "border-t": !row.isFirst },
                )}
            >
                <h2>{row.label}</h2>
                {row.isRecentSearches && onClearRecentSearches && (
                    <button
                        type="button"
                        className="text-xs font-medium text-link hover:text-link/80"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={handleClearRecentSearches}
                    >
                        Clear
                    </button>
                )}
            </div>
        </ComboboxOption>
    );
}
